import { lazy } from 'react'

export const CallsLateVariant1 = lazy(() => import('./CallsLateVariant1'))
